import React from 'react';
import Radio from '@mui/material/Radio';
import _ from 'lodash';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyBox = styled(Box, {
    name: 'StyBox',
})({
    display: 'flex',
    alignItems: 'center',
    height: '34px',
});

export default function RadioCellRenderer<T>({
    data,
    context,
    setSelected,
}: {
    data: T;
    context: { selected: T };
    setSelected: (arg1: T) => void;
}): React.ReactElement {
    return (
        <StyBox>
            <Radio
                checked={_.isEqual(data, context.selected)}
                onChange={() => {
                    setSelected(data);
                }}
            />
        </StyBox>
    );
}
